export function capturePixelEvent(name: string, options = {}) {
  window.fbq("track", name, options);
}

// Recycled

// https://developers.facebook.com/docs/facebook-pixel/advanced/

// For page views ✅
// pixel.event("PageView");

// // For sign-ups (including Google sign-up) ✅
// pixel.event('CompleteRegistration', {
//   method: 'google'
// });

// // For course viewing ✅
// pixel.event("ViewContent", { content_type: "course", content_ids: [courseId] });

// // For adding courses to cart
// pixel.event("AddToCart", { content_ids: [courseId], content_type: "course", value: price, currency: "USD" });

// // For initiating checkout ✅
// pixel.event("InitiateCheckout");

// // For successful purchase (after manual confirmation) ✅
// pixel.event('Purchase', {
//   value: paymentDetails.amount,
//   currency: paymentDetails.currency || 'USD',
//   content_type: 'course',
//   content_ids: paymentDetails.courseIds,
//   transaction_id: paymentId
// });

// // Course completion
// pixel.event('CourseCompleted', {course_id: courseId});

// // Lesson completion
// pixel.event('LessonCompleted', {lesson_id: lessonId, course_id: courseId});

// 06 May 2025

// export function isFbqReady() {
//   return typeof window !== "undefined" && typeof window.fbq === "function";
// }
